import { Box, Tag } from '@coolblue-development/freddy';
import { ReactElement } from 'react';

import { TooltipContainer } from '../../TooltipContainer';
import OnlineStockIconTag from './OnlineStockIconTag';

type OnlineStockIconProps = {
  stockCount?: number;
  url: string;
  index: number;
  totalIndices: number;
};

const OnlineStockIcon = ({
  stockCount,
  url,
  index,
  totalIndices
}: OnlineStockIconProps): ReactElement => {
  if (stockCount === null || stockCount === undefined) {
    return (
      <Box>
        <Tag variant='subtle' intent='neutral'>
          - online
        </Tag>
      </Box>
    );
  }

  const message = stockCount === 0 ? 'None online' : `${stockCount} online`;

  return (
    <TooltipContainer iconLabel='Open Iris product dashboard' data-testid='online-store-stock-icon'>
      <OnlineStockIconTag url={url} index={index} totalIndices={totalIndices} message={message} />
    </TooltipContainer>
  );
};

export default OnlineStockIcon;
